export default __webpack_public_path__ + "static/media/resources_icon_blue.e16a4b70.svg";